import { setHours, setMinutes } from 'date-fns'

export function parseSeparatorDelimitedTime(
  timeString: string,
  separator = ':',
): Date {
  const parts = timeString.split(separator)

  return setMinutes(setHours(new Date(), Number(parts[0])), Number(parts[1]))
}
